var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PartnerPage',{attrs:{"title":"Dev Issues","doc":_vm.doc}},[_c('IconBtn',{attrs:{"title":"Create","icon":"add"},on:{"click":_vm.create}}),_c('List',{staticClass:"my-3",attrs:{"items":_vm.issues}}),_c('Form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }